import { Vue, i18n, wemeikPopup } from './core'
import Rails from '@rails/ujs'
import { convertToCurrency, isTheMaximumQuantity } from '../utils/functions'
import SecureImage from './components/SecureImage'
import additionals from './mixins/additionals'

document.addEventListener('DOMContentLoaded', () => {
  const $el = document.getElementById('product-form')

  if ($el) {
    const PRODUCT_URL = $el.dataset.url
    const CHECKOUT_URL = $el.dataset.checkoutUrl
    window.jQuery(document).ready(function () {
      window.jQuery('[data-toggle="tooltip"]').tooltip()
    })
    new Vue({
      el: $el,
      i18n,
      data: {
        additionals: [],
        hasAdditionals: false,
        hasFractions: false,
        hasObservations: false,
        observations: [],
        product: {
          fraction_id: null,
          price: 0
        },
        quantity: 1,
        maximumQuantity: 9999,
        total: 0,
        unitPrice: 0,
        linkToShare: document.querySelector('link[rel=canonical]') ? document.querySelector('link[rel=canonical]').href : document.location.href,
        loaded: false
      },
      mounted () {
        this.loadProduct()
      },
      components: { 'secure-image': SecureImage },
      mixins: [additionals],
      watch: {
        product: {
          deep: true,
          handler () {
            this.recalculateTotal()
          }
        },
        additionals: {
          deep: true,
          handler () {
            this.recalculateTotal()
          }
        },
        quantity () {
          this.recalculateTotal()
        }
      },
      methods: {
        addProduct (urlRedirect) {
          if (this.quantity <= 0) {
            wemeikPopup({
              title: this.$t('alert.warning'),
              text: this.$t('item.warnings.quantity_less_than_or_equal_to_zero'),
              icon: 'warning'
            })
              .then(() => {
                this.$refs.quantityField.focus()
              })
            return
          }

          if (this.additionalsCount < this.product.min_additionals) {
            wemeikPopup({
              title: this.$t('alert.warning'),
              text: this.$t('additional.warnings.quantity_more_than_or_equal_to') + this.product.min_additionals,
              icon: 'warning'
            })
              .then(() => {
                this.$refs.quantityField.focus()
              })

            return
          }

          const product = Object.assign(this.product, {
            additionals: this.additionals,
            observations: this.observations,
            product_id: this.product.id,
            price: this.unitPrice,
            quantity: this.quantity,
            total: this.total
          })
          if (window.cartStore.addItem(product)) {
            window.location = urlRedirect
          }
        },
        convertToCurrency: convertToCurrency,
        copyLink () {
          navigator.clipboard.writeText(this.linkToShare)
            .then(() => {
              window.jQuery('#buttonTooltip').attr('title', this.$t('statuses.copied')).tooltip('_fixTitle').tooltip('show')
            })
            .catch(err => {
              console.error('Error copying product link: ', err)
            })
        },
        decrementQuantity () {
          const currentQuantity = parseFloat(this.quantity)
          this.quantity = currentQuantity > 0 ? currentQuantity - 1 : currentQuantity
        },
        incrementQuantity () {
          this.quantity = isTheMaximumQuantity(this.quantity, this.maximumQuantity) ? this.quantity : (this.quantity + 1)
        },
        finishOrder () {
          if (window.cartStore.state.count === 0) {
            this.addProduct(CHECKOUT_URL)
          } else {
            wemeikPopup({
              title: this.$t('alert.heads_up'),
              text: this.$t('order.do_you_want_add_this_product'),
              icon: 'info',
              buttons: {
                cancel: this.$t('action.only_finish'),
                confirm: this.$t('action.add_and_finish')
              }
            })
              .then((addProduct) => {
                if (addProduct) {
                  this.addProduct(CHECKOUT_URL)
                } else {
                  window.location.href = CHECKOUT_URL
                }
              })
          }
        },
        loadProduct () {
          Rails.ajax({
            url: PRODUCT_URL,
            type: 'GET',
            dataType: 'json',
            success: (product) => {
              this.setProduct(product)
            },
            error: (error) => {
              console.error('Error quering product: ', error)
            }
          })
        },
        openShares () {
          if (navigator.share) {
            navigator.share({
              title: document.title,
              url: this.linkToShare
            })
              .catch(console.error)
          } else {
            window.jQuery('#shareProduct').modal()
          }
        },
        recalculateTotal () {
          if (this.hasFractions) {
            const selectedFraction = this.product.fractions.find((fraction) => fraction.id === this.product.fraction_id)
            this.unitPrice = parseFloat(selectedFraction.price)
          }

          const quantity = parseFloat(this.quantity)
          let total = quantity * this.unitPrice

          if (this.hasAdditionals) {
            const additionalsTotal = quantity * this.additionals.reduce((accumulator, a) => accumulator + (a.checked ? parseFloat(a.price) : 0), 0)
            total += additionalsTotal
          }

          this.total = total
        },
        setProduct (product = {}) {
          this.product = Object.assign(this.product, product)
          this.additionals = product.additionals
          this.observations = product.observations
          this.maximumQuantity = product.maximum_quantity
          this.product.max_additionals = product.max_additionals === 0 ? product.additionals.length : product.max_additionals

          this.hasAdditionals = Array.isArray(this.product.additionals) && this.product.additionals.length > 0
          this.hasFractions = Array.isArray(this.product.fractions) && this.product.fractions.length > 0
          this.hasObservations = Array.isArray(this.product.observations) && this.product.observations.length > 0

          if (this.hasFractions && !this.product.fraction_id) {
            this.product.fraction_id = this.product.fractions[0].id
            this.unitPrice = parseFloat(this.product.fractions[0].price)
          } else {
            this.unitPrice = parseFloat(this.product.price)
          }

          if (!this.quantity) {
            this.quantity = 1
          }
          this.loaded = true
        }
      }
    })
  }
})
